import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import supabase from '../supabase';
import ReactMarkdown from 'react-markdown';
import { Helmet } from 'react-helmet-async';
import { ChevronLeft, Clock, Share2 } from 'lucide-react';

export default function BlogPosts() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            setLoading(true);
            const { data, error } = await supabase
                .from('blogs')
                .select('*')
                .eq('slug', slug)
                .eq('is_published', true)
                .single();
            
            if (error) console.error("Fetch Error:", error.message);
            setPost(data);
            setLoading(false);
        };
        fetchPost();
    }, [slug]);

    if (loading) return <div className="min-h-screen bg-[#D9D9D9] animate-pulse" />;
    
    if (!post) return (
        <div className="min-h-screen bg-[#D9D9D9] text-black flex flex-col items-center justify-center font-black">
            <h1 className="text-4xl mb-4 uppercase italic tracking-tighter">File Not Found</h1>
            <Link to="/blog" className="bg-black text-white px-6 py-2 uppercase text-xs tracking-widest">Return to Index</Link>
        </div>
    );

    return (
        <div className="bg-[#D9D9D9] min-h-screen  text-black font-poppins pb-20">
            <Helmet>
                <title>{post.title} | Sitemanifest</title>
                <meta name="description" content={post.excerpt} />

                <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": post.title,
            "image": [post.image_url],
            "datePublished": post.created_at,
            "author": [{
                "@type": "Person",
                "name": "Founder",
                "url": "https://sitemanifest.com"
            }]
        })}
    </script>
            </Helmet>

            {/* TOP UTILITY BAR */}
   

            <div className="max-w-3xl mx-auto px-6 pt-32">
                <Link to="/blog" className="group inline-flex items-center gap-2 text-zinc-500 hover:text-black transition-colors mb-12 text-[10px] font-black uppercase tracking-widest">
                    <ChevronLeft size={14} className="group-hover:-translate-x-1 transition-transform" /> Back to Archives
                </Link>

                <div className="flex items-center gap-4 mb-8">
                    <div className="bg-black text-white px-2 py-1 text-[10px] font-black uppercase tracking-widest">
                        {post.category || "General"}
                    </div>
                    <div className="flex items-center gap-1 text-[10px] font-bold uppercase text-zinc-500 tracking-widest">
                        <Clock size={10} /> 5 Minute Forensic Read
                    </div>
                </div>

                <h1 className="text-5xl md:text-7xl font-black italic leading-[0.85] tracking-tighter mb-10 uppercase break-words">
                    {post.title}
                </h1>

                <div className="border-gray-300 p-1 bg-white mb-16 border-2 border">
                    <img 
                        src={post.image_url} 
                        alt="Evidence" 
                        className="w-full aspect-video object-fit  transition-all duration-1000" 
                    />
                </div>

                {/* THE CONTENT RENDERER */}
                <article className="prose prose-zinc max-w-none 
                    prose-h2:text-3xl prose-h2:font-black prose-h2:uppercase prose-h2:italic prose-h2:tracking-tight prose-h2:border-b-4 prose-h2:border-black prose-h2:pb-2
                    prose-p:text-zinc-800 prose-p:text-lg prose-p:leading-relaxed prose-p:font-medium
                    prose-strong:text-black prose-strong:font-black
                    prose-blockquote:border-l-8 prose-blockquote:border-black prose-blockquote:bg-white prose-blockquote:p-6 prose-blockquote:italic
                    prose-a:text-blue-700 prose-a:font-bold hover:prose-a:bg-black hover:prose-a:text-white transition-all">
                    <ReactMarkdown>{post.content}</ReactMarkdown>
                </article>

                {/* CALL TO ACTION - THE HARD CLOSE */}
                <div className="mt-24 p-1 rounded-sm border-2 border-black bg-white shadow-[12px_12px_0px_0px_rgba(0,0,0,1)]">
                    <div className="p-10 text-center border border-dashed border-black">
                        <h2 className="text-4xl font-black uppercase italic mb-4 tracking-tighter">End of Report.</h2>
                        <p className="text-zinc-600 mb-8 font-bold uppercase text-sm tracking-widest">Decision Required: Deploy Sitemanifest or continue the risk.</p>
                        <Link to="/signup" className="inline-block bg-black text-white px-12 py-5 font-black uppercase tracking-[0.2em] hover:bg-zinc-800 transition-colors">
                            Initialize Verification
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}